<template>
    <div id="InformationCheck">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <div class="content">
                    <div class="contentTitle">信息核验</div>
                    <div class="contentVal">
                        <span>三要素实名认证</span>
                        <span>通过加密的手机号、姓名、身份证号来校验三者是否一致</span>
                    </div>
                    <button class="btn" @click="showAlertFlag = true">立即申请</button>
                </div>
            </div>
            <!--定位按钮区域-->
            <div class="btnWrap">
                <span @click="btnEvent(1)" :class="btnIndex === 1 ? 'active' : '' ">API文档</span>
                <span @click="btnEvent(2)" :class="btnIndex === 2 ? 'active' : '' ">错误码参照</span>
                <span @click="btnEvent(3)" :class="btnIndex === 3 ? 'active' : '' ">示例代码</span>
                <span @click="btnEvent(4)" :class="btnIndex === 4 ? 'active' : '' ">联系我们</span>
            </div>
        </div>
        <!--内容区-->
        <router-view/>
        <!--相关产品-->
        <div class="relevantProduct">
            <div class="relevantProductTitle">相关产品</div>
            <!--产品列表-->
            <div class="relevantProductListWrap">
                <!--@click="toPage('/faceRecognition')"-->
                <div class="relevantProductList" style="margin-right: 98px;opacity: 0.3;cursor: not-allowed">
                    <img src="../../assets/img/bigIcon/人脸识别.png"/>
                    <span>人脸识别</span>
                </div>
                <div class="relevantProductList" @click="toPage('/riskWarningReport')" style="margin-right: 82px;">
                    <img src="../../assets/img/bigIcon/风控.png"/>
                    <span>风险预警报告</span>
                </div>
                <!--@click="toPage('/RiskListFiltering')"-->
                <div class="relevantProductList" style="opacity: 0.3;cursor: not-allowed">
                    <img src="../../assets/img/bigIcon/风险名单过滤.png"/>
                    <span>风险名单过滤</span>
                </div>
            </div>
        </div>
        <!--弹框-->
        <div class="alertBox" v-show="showAlertFlag">
            <div class="alertBoxHeader">
                <span>服务咨询</span>
                <img src="../../assets/关闭.png" height="11" width="11" @click="showAlertFlag=false"/>
            </div>
            <div class="alertBoxVal">
                <div>为您提供售前购买咨询、产品推荐等</div>
                <p>电话：<span>0755-86969845</span>（工作日 9:30-18:30）</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InformationCheck",
        data() {
            return {
                btnIndex: 1,
                showAlertFlag: false,
            }
        },
        created() {
            this.btnEvent(1);
            this.eventBus.$on("apiClick", () => {
                this.showAlertFlag = true;
            })
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            toPage(page) {
                this.$router.push({path: page});
            },
            btnEvent(index) {
                this.btnIndex = index;
                switch (index) {
                    case 1:
                        this.$router.push({path: "/InformationApiDocument"});
                        break;
                    case 2:
                        this.$router.push({path: "/InformationErrorCode"});
                        break;
                    case 3:
                        this.$router.push({path: "/InformationExampleCode"});
                        break;
                    case 4:
                        this.showAlertFlag = true;
                        break;
                }
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("relevantProduct")[0], "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
            this.eventBus.$off("apiClick");
        }
    }
</script>

<style lang="scss" scoped>
    #InformationCheck {
        position: relative;

        .bannerWrap {
            background: url("../../assets/img/ristWarning/信息核验banner.png") no-repeat center;
            background-color: #00092E;

            .content {
                margin-top: -8px;
            }
        }

        .relevantProduct {
            width: 436px;
        }

    }
</style>
